/* eslint-disable no-lonely-if */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-else-return */
/* eslint-disable no-restricted-syntax */
/* eslint-disable guard-for-in */
/* eslint-disable prefer-const */
/* eslint-disable no-loop-func */
/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable prefer-destructuring */
/* eslint-disable object-shorthand */
/* eslint-disable no-var */
/* eslint-disable prefer-template */
/* eslint-disable dot-notation */
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

import { Observable, of, zip } from 'rxjs';
import { map, mergeMap, tap } from 'rxjs/operators';
import {
  BreadCrumbRouteConfig,
  DomainService,
  EntityResolverService,
  TokenService
} from 'viggo-sistemas-core-web';

import { IMunicipio } from '@app/modules/parametrizacao/municipio/model/municipio.model';
import { MunicipioService } from '@app/modules/parametrizacao/municipio/services/municipio.service';
import { ValidadorSettingsApplication } from '@app/shared/utils/validar_settings_application';

import { TagsList } from '../../../produto/model/produto.model';
import { TagsService } from '../../../tags/services/tags.service';
import { IVendedor } from '../../model/vendedor.model';
import { VendedorService } from '../vendedor-service/vendedor.service';
import { ISettings } from '../vendedor-settings/vendedor-settings.service';
/**
 * Proviver resolve que fornece informações para components de rotas que precisam
 * trazer informações para vendedores.
 */
@Injectable()
export class VendedorResolverService extends EntityResolverService<IVendedor> {
  constructor(
    protected tokenService: TokenService,
    protected router: Router,
    protected entityService: VendedorService,
    protected municipioService: MunicipioService,
    protected tagsService: TagsService,
    protected snackBar: MatSnackBar,
    protected domainService: DomainService
  ) {
    super({
      urlListEntity: 'vendedor'
    });
  }

  protected newEntity(): Observable<IVendedor> {
    return of({
      parceiro: {}
    } as IVendedor);
  }

  setarBreadcrumb(vendedor: IVendedor, rota: ActivatedRouteSnapshot) {
    const config = {
      label: `${vendedor.id ? 'Editar' : 'Adicionar'} vendedor`,
      icon: 'pi pi-fw pi-pencil'
    } as BreadCrumbRouteConfig;

    Object.assign(rota.routeConfig, {
      data: { ...rota.data, breadcrumb: config }
    });
  }

  resolve(route: ActivatedRouteSnapshot): Observable<IVendedor> {
    if (route.url[route.url.length - 1].path === 'edit') {
      this.included = ['parceiro', 'user', 'equipe_venda'];
    } else this.included = ['parceiro', 'user'];
    const id = route.paramMap.get('id');
    const fnPipe = () => {
      return tap((entity: IVendedor) => {
        this.setarBreadcrumb(entity, route);
      });
    };

    const getAgendamento = () => {
      return mergeMap((entity: IVendedor) => {
        const { application } = this.tokenService.getDomain();
        application.settings = new ValidadorSettingsApplication(
          application.settings
        ).getApplicationSettingsBody(application.settings) as any;
        if (application.settings['regras']['tipo_perfil'] === 'ATACADO') {
          const primeiroDiaDoMes = new Date(
            new Date().getFullYear(),
            new Date().getMonth(),
            1
          );
          const ultimoDiaDoMes = new Date(
            new Date().getFullYear(),
            new Date().getMonth() + 1,
            0
          );
          const de =
            primeiroDiaDoMes.getFullYear() +
            '-' +
            (primeiroDiaDoMes.getMonth() + 1) +
            '-' +
            1;
          const ate =
            ultimoDiaDoMes.getFullYear() +
            '-' +
            (ultimoDiaDoMes.getMonth() + 1) +
            '-' +
            ultimoDiaDoMes.getDate();
          const req = this.entityService.agendamento(
            { de, ate },
            entity.id,
            this.tokenService.getDomain().id
          );
          return req.pipe(
            map(value => {
              var totVisitas = 0;
              var totVisitados = 0;
              value.agenda = value.agenda.map(item => {
                totVisitados += item.visitou_c.length;
                totVisitas += item.visitas_c.length;
                return { ...item, date_: new Date(item.date) };
              });
              return {
                ...entity,
                agenda_value: {
                  agenda: value.agenda,
                  totVisitas: totVisitas,
                  totVisitados: totVisitados
                }
              };
            })
          );
        } else return of(entity);
      });
    };

    const getValueDomain = () => {
      return mergeMap((entity: IVendedor) => {
        const req = this.domainService.getEntity(
          this.tokenService.getDomain().id
        );
        return req.pipe(
          map((value: ISettings) => {
            return {
              ...entity,
              settings_domain:
                value.settings === undefined ? null : value.settings
            };
          })
        );
      });
    };

    const getTagsContato = () => {
      return mergeMap((entity: IVendedor) => {
        var observers: Observable<any>[] = [];
        const tags_back = [] as TagsList[];
        let tags: string[];
        if (
          entity.parceiro.contatos === undefined ||
          !entity.parceiro.contatos.length
        )
          return of(entity);
        else {
          entity.parceiro.contatos.forEach(c => {
            tags = typeof c.tag === 'string' ? c.tag.split(' ') : c.tag;
          });
          tags.forEach(() => {
            const prevTags = tags;
            const index = tags.findIndex(tg => tg === '');
            if (index >= 0) {
              prevTags.splice(index, 1);
              tags = prevTags;
            }
          });
          if (tags.length === 0) return of(entity);
          for (let i in tags) {
            observers.push(
              this.tagsService.getEntitiesByParams(
                `&list_options=ACTIVE_ONLY&tag_name=${tags[i].split('#')[1]}`,
                this.tokenService.getDomain().id,
                false
              )
            );
          }
          return zip(...observers).pipe(
            map(obs => {
              obs.forEach(t => {
                if (t.length !== 0) {
                  const prevTags = tags;
                  tags_back.push({ value: t[0].tag_name, color: t[0].color });
                  t[0].tag_name = t[0].tag_name.split(' ')[0];
                  const index = tags.findIndex(tg => t[0].tag_name === tg);
                  if (index >= 0) {
                    prevTags.splice(index, 1);
                    tags = prevTags;
                  }
                } else {
                  const prevTags = tags;
                  for (let i in tags) {
                    obs.find(t => {
                      if (t.length !== 0) {
                        t[0].tag_name = t[0].tag_name.split(' ')[0];
                        const index = tags.findIndex(
                          () => t[0].tag_name === tags[i]
                        );
                        if (index >= 0) {
                          prevTags.splice(index, 1);
                          tags = prevTags;
                        }
                      } else {
                        tags_back.push({ value: tags[i], color: 'gray' });
                        const index = tags.findIndex(tg => tg === tags[i]);
                        if (index >= 0) {
                          prevTags.splice(index, 1);
                          tags = prevTags;
                        }
                      }
                    });
                  }
                }
              });
              entity.parceiro.contatos = entity.parceiro.contatos.map(c => {
                return { ...c, tags: tags_back };
              });
              return { ...entity };
            })
          );
        }
      });
    };

    const checkVendedorCatalogo = () => {
      return tap((entity: IVendedor) => {
        this.entityService
          .getEntitiesByParams(
            `domain_id=${this.tokenService.getDomain().id}&padrao_catalogo=true`
          )
          .subscribe((exists: IVendedor[]) => {
            if (exists.length && id === exists[0].id)
              localStorage.setItem('ocultaCheckCatalogo', 'false');
            else {
              if (exists.length)
                localStorage.setItem('ocultaCheckCatalogo', 'true');
              else localStorage.setItem('ocultaCheckCatalogo', 'false');
            }
          });
      });
    };

    if (id === 'new')
      return this.newEntity().pipe(
        fnPipe(),
        getValueDomain(),
        checkVendedorCatalogo()
      );

    return super.resolve(route).pipe(
      fnPipe(),
      getValueDomain(),
      getTagsContato(),
      // getAgendamento(),
      checkVendedorCatalogo(),
      mergeMap(vendedor => {
        let observers = [];

        if (vendedor.parceiro.enderecos.length === 0) return of(vendedor);

        observers = vendedor.parceiro.enderecos.map(({ municipio_id }) =>
          this.municipioService.getEntity(municipio_id)
        );

        if (observers.length === 0) return of(vendedor);

        const obs = zip<IMunicipio[]>(...observers).pipe(
          map(municipios => {
            if (municipios.length === 0 || !municipios) return vendedor;

            municipios.forEach(municipio => {
              const index = vendedor.parceiro.enderecos.findIndex(
                endereco => endereco.municipio_id === municipio.id
              );
              if (index >= 0) {
                vendedor.parceiro.enderecos[index].municipio = municipio;
              }
            });
            vendedor.parceiro.cpf_cnpj = vendedor.parceiro.cpf_cnpj.trim();
            return vendedor;
          })
        );
        return obs;
      })
    );
  }
}
